'use client';
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import AdminRevenueChart from '@/app/admin-dashboard/components/AdminRevenueChart';
import AdminKPIGrid from '@/app/admin-dashboard/components/AdminKPIGrid';

function exportReport() {
  const rows = [
    ['Metric', 'Value', 'Change', 'Period'],
    ['Total Revenue', '£24,580', '+12%', 'This Month'],
    ['Jobs Completed', '142', '+8%', 'This Month'],
    ['Active Cleaners', '38', '+3', 'This Month'],
    ['Customer Satisfaction', '4.9/5', '+0.1', 'This Month'],
    ['Job Completion Rate (30d)', '97.2%', '+1.2%', 'Last 30 Days'],
    ['Cleaner Utilization', '78%', '+5%', 'Last Week'],
    ['Customer Retention', '84%', '+3%', 'Last Quarter'],
    ['Revenue Forecast (Q2)', '£89,400', '+18%', 'vs Q1'],
  ];

  const csvContent = rows?.map(row => row?.map(cell => `"${cell}"`)?.join(','))?.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `cleanflow-report-${new Date()?.toISOString()?.slice(0, 10)}.csv`;
  document.body?.appendChild(link);
  link?.click();
  document.body?.removeChild(link);
  URL.revokeObjectURL(url);
}

export default function AdminReportsPage() {
  return (
    <DashboardLayout role="admin">
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-extrabold text-foreground">Reports</h1>
            <p className="text-sm text-muted-foreground mt-0.5">Business performance and analytics reports</p>
          </div>
          <button
            onClick={exportReport}
            className="px-4 py-2.5 rounded-xl border border-border text-sm font-semibold text-foreground hover:bg-muted transition-colors active:scale-95 w-fit"
          >
            Export Report
          </button>
        </div>
        <AdminKPIGrid />
        <AdminRevenueChart />
      </div>
    </DashboardLayout>
  );
}
